<template>
    <div class="md-testimionial agent-info">
        <div class="agent-basic">
            <AgentHeadShot class="agent-image" :headshots="agent.headShots" :initImage="agent.image" dir="height" keyClass="md-testimonial-reviews-online"></AgentHeadShot>
            <div class="info-container">
                <p class="info-name">{{ agent.fullName }}</p>
                <p class="info-position">{{ agent.position }}</p>
                <div class="info-message">
                    <p class="license">{{ licenseName }}{{ agent.license }}</p>
                    <p class="phone">
                        {{ $t('md-testimonial.tel')
                        }}<a
                            :href="'tel:' + agent.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >{{ $ft.formatPhone(agent.phone) }}</a
                        >
                    </p>
                    <p class="email">
                        {{ $t('md-testimonial.email')
                        }}<a
                            :href="'mailto:' + agent.email"
                            target="_top"
                            rel="noopener noreferrer"
                        >{{ agent.email }}</a
                        >
                    </p>
                </div>
                <!--  make sure  agent.name  Show only if there is a name  -->
                <agent-share
                    v-if="agent.fullName"
                    :agentName="agent.fullName"
                    :socialNetworks="agent.socialNetworks"
                ></agent-share>
            </div>
        </div>
        <div v-if="showIntrod" class="agent-intro">
            <div v-if="logo" class="logo">
                <site-img :src="logo" />
            </div>
            <!-- TODO: warn  XSS  risk  -->
            <view-more
                v-if="agent.longIntroduction"
                class="introduce"
                :content="agent.longIntroduction"
                :moreText="$t('readMore')"
                :line="10"
                :mobileLine="10"
            ></view-more>
        </div>
    </div>
</template>

<script>
import viewMore from '@/components/view-more.vue';
import agentShare from './agent-share.vue';
import { mapState } from 'pinia';
import { usePageStore } from "@/store";
import AgentHeadShot from "@/components/agent-headshot.vue"

export default {
    name: 'agent-info',
    i18next: {
        ns: 'md-testimonial'
    },
    components: {
        agentShare,
        viewMore,
        AgentHeadShot
    },
    props: {
        agent: {
            type: Object,
            default: () => ({})
        },
        showIntrod: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            logo: ''
        };
    },
    computed: {
        ...mapState(usePageStore, {
            licenseName: store => store.page?.licenseName
        }),
    },
    created() {
        //  currently hide this  logo
        // this.getCompanyInfo();
    },
    methods: {
        getCompanyInfo() {
            this.axiosIns
                .get('/api-site/place-data', {
                    params: {
                        fetcher: 'data',
                        fields: 'logo'
                    }
                })
                .then(({ data = {} }) => {
                    this.logo = data.logo || '';
                })
                .catch(errorInfo => {
                    console.log(errorInfo);
                });
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';

.md-testimionial.agent-info {
    $agent-width: 300px;
    border: solid 1px rgba(73, 73, 73, 0.2);

    width: $agent-width;
    .agent-image {
        height: $agent-width;
    }
    .info-container {
        padding: 20px 20px 0;
        text-align: center;

        .info-name {
            font-family: var(--font-bold);
            font-size: 28px;
            color: #282828;
            line-height: normal;
        }
        .info-position {
            margin-top: 12px;
            line-height: 24px;
            border-radius: 2px;
            background-color: #312306;
            display: inline-block;
            padding: 0 11px;
            text-transform: uppercase;
            color: #ffffff;
            font-size: 15px;
            font-family: var(--font-bold);
        }
        .info-message {
            font-size: 16px;
            color: #000;
            margin-top: 8px;
            .email {
                @include ellipsis;
            }
        }
        .share-box {
            padding-bottom: 30px;
            border-bottom: 1px solid #e6e6e6;
        }
    }
    .agent-intro {
        padding: 30px 20px 0;
        .logo {
            height: 30px;
            text-align: center;
            img {
                height: 100%;
            }
        }
        .introduce {
            margin-top: 12px;
            font-size: 15px;
            line-height: 20px;
            color: #505050;
            .more-btn {
                margin-top: 4px;
                text-align: center;
                font-family: var(--font-black);
                color: #f3ab1a;
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }
}
</style>
